import PropTypes from 'prop-types';

import { getColor } from 'basic-components';

const CustomLinkArrowWidget = ({ point, prevPoint = undefined }) => {
  const transform = 'translate(-4, -13)'
  let angle = -90;
  if(prevPoint) { // smart routing is disabled
    angle = (-90 +
      (Math.atan2(
        point.getPosition().y - prevPoint.getPosition().y,
        point.getPosition().x - prevPoint.getPosition().x
      ) * 180) / Math.PI)
  }
  return (
    <g
        className="arrow"
        transform={
          "translate(" +
          point.getPosition().x +
          ", " +
          point.getPosition().y +
          ")"
        }
    >
      <g style={{ transform: "rotate(" + angle + "deg)" }}>
        <g transform={transform}>
          <line
              data-id={point.getID()}
              data-linkid={point.getLink().getID()}
              stroke={getColor("grey-base")}
              x1="0"
              x2="4"
              y1="3"
              y2="7"
          />
          <line
              data-id={point.getID()}
              data-linkid={point.getLink().getID()}
              stroke={getColor("grey-base")}
              x1="4"
              x2="8"
              y1="7"
              y2="3"
          />
        </g>
      </g>
    </g>
  )
}

CustomLinkArrowWidget.propTypes = {
  point: PropTypes.any.isRequired,
  prevPoint: PropTypes.any,
}

export default CustomLinkArrowWidget;
